import React from "react";
import { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { Table } from "react-bootstrap";
import { makeStyles } from "@material-ui/core/styles";
import { CSVLink } from "react-csv";
import csv_icon from "../../../assets/images/csv icon.png";
import { API } from "../../../Services/api-services";
import Error from "../../../assets/images/err.png";
const moment = require("moment");

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const useStyles = makeStyles((theme) => ({
  rowStyle: {
    width: "150px",
    textAlign: "center",
    padding: "10px",
  },
  thead: {
    width: "150px",
    textAlign: "center",
    color: "#2761BA",
  },
  note: {
    padding: "5px 15px 5px 15px",
    fontSize: "14px",
  },
}));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography style={{ textAlign: "center" }} variant="h6">
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

function TotalBatchClasses(props) {
  const [open, setOpen] = useState(props.open);
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [err, setErr] = useState(false);
  useEffect(() => {
    API.post("/dashboardDetails", {
      section: 6,
      startDate: props.startDate,
    })
      .then((res) => {
        setData(
          res.data.response.map((d) => {
            if (d.delay) {
              const duration = moment.duration(d.delay, "seconds");
              d.delay = moment.utc(duration.asMilliseconds()).format("mm:ss");
            }
            if (d.meetingDuration) {
              const durationInMinutes = moment.duration(
                d.meetingDuration,
                "minutes"
              );
              d.meetingDuration = moment
                .utc(durationInMinutes.asMilliseconds())
                .format("HH:mm:ss");
            }

            if (d.videoOnDuration) {
              convertMinutesToTime(d.videoOnDuration);
            }
            return {
              ...d,
              date: moment(d.indiaStartTime).format("MMM Do YY"),
              time: moment(d.indiaStartTime).format("hh:mm A"),
            };
          })
        );
      })
      .catch((e) => {
        setErr(true);
        console.log("err", e);
      });
  }, [props.startDate]);

  const handleClose = () => {
    props.displayTotalBatches(false);
  };
  const getColor = (status) => {
    if (status == "Cancelled") return "#FFA749";
    else if (status == "Attended") return "#28B844";
    else return "#F45252";
  };
  const getColorDuration = (time1, type) => {
    if (type === "classDuration") {
      const time2 = 3000;
      const [hours, minutes, seconds] = time1.split(":").map(Number);
      const delayInSeconds = hours * 3600 + minutes * 60 + seconds;
      if (delayInSeconds < time2) return "#F45252";
    } else {
      const time2 = 180;
      const [minutes, seconds] = time1.split(":").map(Number);
      const delayInSeconds = minutes * 60 + seconds;
      if (delayInSeconds > time2) return "#F45252";
    }
  };

  const convertMinutesToTime = (minutes) => {
    const seconds = minutes * 60;
    const duration = moment.duration(seconds, "seconds");
    const hours = duration.hours().toString().padStart(2, "0");
    const minutesFormatted = duration.minutes().toString().padStart(2, "0");
    const secondsFormatted = duration.seconds().toString().padStart(2, "0");

    return `${hours}:${minutesFormatted}:${secondsFormatted}`;
  };

  const headers = [
    { label: "Date", key: "date" },
    { label: "Time", key: "time" },
    { label: "Batch Name", key: "batchName" },
    { label: "Topic", key: "topic" },
    { label: "Status", key: "status" },
    { label: "Class Duration", key: "meetingDuration" },
    { label: "Video Duration", key: "videoOnDuration" },
    { label: "Delay", key: "delay" },
  ];
  return (
    <div style={{ maxHeight: "762px" }}>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth="lg"
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Total Classes
        </DialogTitle>
        <DialogContent>
          {err ? (
            <img src={Error} />
          ) : (
            <Table>
              <thead>
                <tr style={{ backgroundColor: "#F5F9FF" }}>
                  <th className={classes.thead}>Date</th>
                  <th className={classes.thead}>Time (IST)</th>
                  <th className={classes.thead}>Batch Name</th>
                  <th className={classes.thead}>Topic</th>
                  <th className={classes.thead}>Status</th>
                  <th className={classes.thead}>Class Duration</th>
                  <th className={classes.thead}>Video Duration</th>
                  <th className={classes.thead}>Delay</th>
                </tr>
              </thead>
              <tbody>
                {data.map((d, idx) => {
                  return (
                    <tr key={idx}>
                      <td className={classes.rowStyle}>
                        {moment(d.indiaStartTime).format("YYYY-MM-DD")}
                      </td>
                      <td className={classes.rowStyle}>{d.time}</td>
                      <td className={classes.rowStyle}>{d.batchName}</td>
                      <td className={classes.rowStyle}>{d.topic}</td>
                      <td
                        className={classes.rowStyle}
                        style={{ color: getColor(d.status) }}
                      >
                        {d.status}
                      </td>
                      <td
                        style={{
                          color:
                            d.violations &&
                            d.violations.hasOwnProperty("meetingDuration") &&
                            d.violations.meetingDuration === 1 &&
                            "#E34935",
                        }}
                        className={classes.rowStyle}
                      >
                        {d.meetingDuration ? d.meetingDuration : "-"}
                      </td>
                      <td
                        style={{
                          color:
                            d.violations &&
                            d.violations.hasOwnProperty("videoOn") &&
                            d.violations.videoOn === 1 &&
                            "#E34935",
                          // : "#7A7A7A",
                        }}
                        className={classes.rowStyle}
                      >
                        {d.videoOnDuration
                          ? convertMinutesToTime(d.videoOnDuration)
                          : "-"}
                      </td>
                      <td
                        style={{
                          color: d.delay && getColorDuration(d.delay, "delay"),
                        }}
                        className={classes.rowStyle}
                      >
                        {d.delay ? d.delay : d.delay == "0" ? "00:00" : "-"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          )}
        </DialogContent>
        {!err && (
          <DialogActions>
            <CSVLink data={data} headers={headers} filename="Total_Classes.csv">
              <p
                style={{
                  color: "#FF4747",
                  fontWeight: 600,
                  marginRight: "10px",
                  marginBottom: "10px",
                }}
              >
                Download
                <span style={{ marginLeft: "10px" }}>
                  <img src={csv_icon} />
                </span>
              </p>
            </CSVLink>
          </DialogActions>
        )}
      </Dialog>
    </div>
  );
}

export default TotalBatchClasses;
